//@flow
import React from 'react';
import Head from 'next/head';
import { Client } from '../prismic-configuration';
import { RichText } from 'prismic-reactjs';
import { PrismicSupportPledgeDoc } from '../types/prismic';
import { PageWrapper } from '../components/base';
import styles from '../styles/pages/support-pledge.module.sass';

type Props = {
  doc: PrismicSupportPledgeDoc;
};

const DonatePage = ({ doc }: Props) => {
  const { page_title, header, subheader, disclaimer } = doc.data;

  return (
    <PageWrapper title={page_title}>
      <Head>
        <script
          src="https://donorbox.org/widget.js"
          // @ts-ignore
          paypalexpress="false"
        />
      </Head>
      <section className="section-first full-width">
        <section
          className={`inner-width inner-width-padding column center text-center ${styles.donor}`}
        >
          <h1 className="sr">{page_title}</h1>
          <h2>{header}</h2>
          <p>{subheader}</p>
        </section>
        <section className={`column center text-center ${styles.donor}`}>
          <div className={styles.donorbox}>
            <iframe
              // @ts-ignore
              allowpaymentrequest=""
              name="donorbox"
              scrolling="no"
              seamless={true}
              src="https://donorbox.org/embed/15percentpledge"
              style={{
                width: '100%',
                maxWidth: '100%',
                minWidth: '250px',
                maxHeight: 'none !important',
              }}
              width="100%"
              height="900px"
              frameBorder="0"
            />
          </div>
          <div className={styles.disclaimer}>
            <RichText render={disclaimer} />
          </div>
        </section>
      </section>
    </PageWrapper>
  );
};

export async function getServerSideProps() {
  const client = Client();
  const doc = await client.getSingle('support-pledge', {});

  return {
    props: {
      doc,
    },
  };
}

export default DonatePage;
